import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { ModerationQueue } from "@/features/admin/components/moderation-queue";
import { PageContainer } from "@/components/ui/page-container";

function AdminModerationPage() {
  return (
    <PageContainer maxWidth="6xl">
      <ModerationQueue />
    </PageContainer>
  );
}

export const adminModerationRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/moderation",
  component: AdminModerationPage,
});
